/**
 * Politica de Seguranca Cibernetica e da Informacao da Empiria, versao de 22
 * de julho de 2026.
 *
 * ATENCAO: diferente dos outros modulos desta pasta, este NAO e transcricao
 * integral. O documento aprovado e o mais interno dos seis -- distribui papeis
 * entre diretorias e gerencias, define deveres de colaboradores e prestadores
 * de servico e descreve controles do ambiente de TI. Publicar isso na integra
 * seria expor a planta da casa.
 *
 * O que esta aqui e o recorte que interessa a quem usa a Plataforma, porque o
 * item 10.1 da Politica de Cookies e Privacidade manda o titular acessar esta
 * politica -- sem uma pagina, aquele link morre.
 *
 * A numeracao original foi mantida nos itens que vieram do documento, para que
 * a citacao "item 5.1.13" continue apontando para o mesmo lugar nos dois.
 *
 * O texto integral continua disponivel a quem pedir pelo canal do Encarregado.
 *
 * O item 5.2 do PDF manda comunicar falhas para empiriapp@gmail.com, unico
 * endereco de todos os seis documentos fora do dominio proprio -- e logo num
 * item sobre seguranca. Publicamos seguranca@empiriapp.com.br.
 *
 * O resumo e a troca do endereco precisam do aval do cliente: cobranca anotada
 * em PENDENCIAS_COM_O_CLIENTE.txt, na raiz do projeto.
 */
const seguranca = [
    {
        tipo: "texto",
        texto:
            "Esta página apresenta, em versão resumida, a Política de Segurança Cibernética e da Informação da Empiria, aprovada pela Diretoria Executiva em 21 de julho de 2026 e publicada em 22 de julho de 2026. O documento completo trata também da organização interna da Empiria — papéis entre diretorias e gerências, deveres de colaboradores e de prestadores de serviço e detalhes dos controles do ambiente de tecnologia — e por isso não é publicado na íntegra. Se você precisar do texto completo, peça pelo e-mail do Encarregado de Dados indicado no final desta página.",
    },
    {
        tipo: "secao",
        texto: "O QUE ESTA POLÍTICA GARANTE A VOCÊ",
    },
    {
        tipo: "item",
        id: "3.1.",
        texto:
            "A política estabelece os princípios e as diretrizes que a Empiria observa no tratamento e na proteção das informações da companhia e do seu ambiente cibernético — o que inclui os dados que você confia à Plataforma ao criar uma conta, contratar um Encontro ou participar de um deles.",
    },
    {
        tipo: "item",
        id: "4.1.",
        texto:
            "Todo tratamento de dados pela Empiria se apoia em três pilares: confidencialidade, integridade e disponibilidade.",
    },
    {
        tipo: "item",
        id: "4.1.1.",
        texto:
            "Confidencialidade: a informação tratada não deve ser divulgada para pessoas sem autorização de acessá-la.",
    },
    {
        tipo: "item",
        id: "4.1.2.",
        texto:
            "Integridade: a informação tratada não deve ser alterada sem autorização apropriada.",
    },
    {
        tipo: "item",
        id: "4.1.3.",
        texto:
            "Disponibilidade: a informação tratada pode ser armazenada, acessada ou protegida a qualquer tempo.",
    },
    {
        tipo: "secao",
        texto: "COMO A EMPIRIA PROTEGE OS DADOS",
    },
    {
        tipo: "texto",
        texto:
            "A Empiria mantém um programa permanente de segurança da informação. Os controles abaixo são os que alcançam diretamente os dados de quem usa a Plataforma; a política completa descreve outros, voltados ao ambiente interno da Empresa.",
    },
    {
        tipo: "item",
        id: "5.1.1.",
        texto:
            "Classificação dos dados: as informações são classificadas conforme o seu valor, a sua sensibilidade, a sua criticidade e as obrigações legais e contratuais que recaem sobre elas, e cada classificação determina como aquela informação pode ser tratada.",
    },
    {
        tipo: "item",
        id: "5.1.2.",
        texto:
            "Desenvolvimento voltado para privacidade e segurança: a Empiria mantém equipes dedicadas à criação e à melhoria dos instrumentos de segurança das suas aplicações, com foco em dados pessoais e observando as exigências legais e as melhores técnicas conhecidas no mercado.",
    },
    {
        tipo: "item",
        id: "5.1.5.",
        texto:
            "Gestão de acessos: o acesso ao ambiente de tecnologia segue procedimentos formais de concessão, revogação, transferência, revisão e autenticação. Ninguém acessa uma informação por estar dentro da Empresa: acessa quem tem autorização para aquilo.",
    },
    {
        tipo: "item",
        id: "5.1.7.",
        texto:
            "Gestão de redes e de criptografia: o fluxo de dados entre os componentes dos sistemas é protegido por segmentação de redes, padrões de configuração seguros e criptografia forte.",
    },
    {
        tipo: "item",
        id: "5.1.8.",
        texto:
            "Gestão de vulnerabilidades: varreduras e testes de segurança são realizados de forma recorrente por equipe especializada, e as falhas encontradas são tratadas pelas equipes de segurança cibernética e de desenvolvimento.",
    },
    {
        tipo: "item",
        id: "5.1.10.",
        texto:
            "Gestão de fornecedores: antes de contratar um fornecedor, a Empiria avalia os riscos envolvidos e verifica a conformidade dele com as regras de segurança da Empresa, na medida do serviço que ele vai prestar.",
    },
    {
        tipo: "item",
        id: "5.1.11.",
        texto:
            "Registros de auditoria: trilhas automatizadas registram eventos de segurança, de autenticação e ações executadas, o que permite rastrear o que aconteceu e quando.",
    },
    {
        tipo: "item",
        id: "5.1.12.",
        texto:
            "Prevenção do vazamento de informações: soluções automatizadas detectam, restringem e alertam sobre a circulação indevida de dados dentro do ambiente de tecnologia.",
    },
    {
        tipo: "item",
        id: "5.1.13.",
        texto:
            "Plano de contingência: a Empiria mantém plano de recuperação segura dos dados e das funcionalidades dos seus sistemas em caso de indisponibilidade de serviços críticos, com backup em mais de um datacenter.",
    },
    {
        tipo: "item",
        id: "5.1.15.",
        texto:
            "Gestão de incidentes: existe um processo para prevenir, detectar, responder e recuperar-se de eventos inesperados. Todo incidente reportado passa por identificação, análise, classificação e comunicação, de acordo com os seus efeitos e com o interesse das partes envolvidas e eventualmente afetadas.",
    },
    {
        tipo: "secao",
        texto: "ENCONTROU UMA FALHA? AVISE A GENTE",
    },
    {
        tipo: "item",
        id: "5.2.",
        texto:
            "Se você identificar qualquer inconsistência ou falha no ambiente da Empiria, comunique pelo e-mail seguranca@empiriapp.com.br. O aviso é analisado pela equipe de segurança, e a comunicação de quem reporta é tratada com a mesma confidencialidade das demais informações da Plataforma.",
    },
    {
        tipo: "secao",
        texto: "REVISÃO E VIGÊNCIA",
    },
    {
        tipo: "item",
        id: "9.1.",
        texto:
            "A política é revisada no prazo mínimo de um ano ou, extraordinariamente, a qualquer tempo.",
    },
    {
        tipo: "item",
        id: "10.1.",
        texto:
            "A versão vigente foi apreciada e aprovada pela Diretoria Executiva em 21 de julho de 2026 e entrou em vigor com a publicação em 22 de julho de 2026.",
    },
    {
        tipo: "secao",
        texto: "REFERÊNCIAS",
    },
    {
        tipo: "texto",
        texto:
            "A política foi construída a partir das normas ABNT NBR ISO/IEC 27001:2022 e 27002:2022, da Lei nº 13.709/2018 (Lei Geral de Proteção de Dados), do Decreto nº 8.771/2016, que regulamenta o Marco Civil da Internet quanto ao tratamento de dados pessoais e à segurança das informações, do Decreto nº 9.637/2018 (Política Nacional de Segurança da Informação), do Decreto nº 10.222/2020 (Estratégia Nacional de Segurança Cibernética), do Decreto nº 11.586/2023 (Política Nacional de Segurança Cibernética) e da Resolução CGPAR nº 41/2022. A Empiria não é instituição financeira e não está sujeita à Resolução CMN nº 4.893/2021, mas a adota como referência de boas práticas.",
    },
    {
        tipo: "texto",
        texto:
            "Dúvidas sobre esta política, ou pedido do documento na íntegra: dpo@empiriapp.com.br, canal do Encarregado de Dados da Empiria.",
    },
];

export default seguranca;
